<template>
  <div>
    <div class="row">
      <div class="col-12 p-md-0">
        <div class="section-title">{{ currentSection.name }}</div>
      </div>
    </div>
    <div class="row mt-3 m-2 ">
      <div class="col-12 ">
        <carousel :per-page-custom="[[320, 1], [420, 2],[830, 4]]" :mouse-drag="true" :navigationEnabled="true">
          <slide
            class="col-md-3 "
            v-for="child in cardsBySectionId(currentSection.id)"
            :key="child.id"
          >
            <panel-card :cardId="child.id"></panel-card>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import CardHelperMixin from "@/components/homepage/mixins/CardHelperMixin";
import PanelCard from "@/components/homepage/PanelCard";

export default {
  mixins: [CardHelperMixin],
  components: {
    Carousel,
    Slide,
    PanelCard,
  },
};
</script>

<style>
.card {
  border: none !important;
}
</style>